export function Theme90sMarquee() {
  return (
    <div className="theme-90s-marquee theme-90s-ornament">
      <span style={{ color: '#FFFF00' }}>★★★</span>
      &nbsp;&nbsp;
      WELCOME TO FAIRMINT BRAIN —{' '}
      <span className="theme-90s-blink">HOT</span> NEW AI ANSWERS, ASK ANYTHING!
      &nbsp;&nbsp;
      <span style={{ color: '#FFFF00' }}>★★★</span>
    </div>
  );
}
